import React, { useState } from 'react';
import { translate } from 'components/Translation';
import { BodyM } from 'components/Typography/Typography';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/servicesStyle';
import { makeStyles } from '@material-ui/core';
import JawazakTable from 'components/ServicesTables/JawazakTable';
import { CustomAttribute, extractAttributeValue } from 'utils/ecommerce/services/extract';
import DialogTermsAndConditions from 'views/Numbers/Details/Services/subcomponents/common/DialogTermsAndConditions';
import { jawazakActivationPackageName } from '../helpers';
import VatClause from 'components/VatClause/VatClause';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IJawazakActivationDialogProps {
	catalogEntryView: types.ecommerce.CatalogEntryView[];
	isOpen: boolean;
	hideDialog: () => void;
	termsAndConditions: types.services.termsAndConditions;
	updateOrderItems: types.services.updateOrderItemsFunction;
}

const JawazakActivationDialog = ({
	catalogEntryView,
	isOpen,
	hideDialog,
	termsAndConditions,
	updateOrderItems,
}: IJawazakActivationDialogProps) => {
	const classes = useStyles();
	const [selectedCatalogEntryView, setSelectedCatalogEntryView] = useState<types.ecommerce.CatalogEntryView | null>(
		null
	);
	const [isChecked, setIsChecked] = useState<boolean>(false);
	const [showError, setShowError] = useState<boolean>(false);
	const activationButtonDisabled = !selectedCatalogEntryView || (showError && !isChecked);

	const activateJawazak = () => {
		if (!isChecked) {
			setShowError(true);
		} else {
			setShowError(false);
			if (selectedCatalogEntryView) {
				hideDialog();
				const place = extractAttributeValue(
					{ attributes: selectedCatalogEntryView.attributes },
					CustomAttribute.DEFINITION_SOURCE
				);
				const ebuConfigProduct = extractAttributeValue(
					{ attributes: selectedCatalogEntryView.attributes },
					CustomAttribute.EBU_CONFIG_PRODUCT
				);
				const orderItems: types.services.IOrderItem[] = [];
				const addItem: types.services.IOrderItem = {
					action: 'ADD',
					id: selectedCatalogEntryView.partNumber,
					place,
					ebuConfigProduct,
				};
				orderItems.push(addItem);
				const name = jawazakActivationPackageName(selectedCatalogEntryView);
				updateOrderItems(orderItems, 'TURN_ON', name, true);
			}
		}
	};

	return (
		<CustomDialog
			isOpen={isOpen}
			hideDialog={hideDialog}
			width={690}
			header={translate('number.services.jawazak.activation')}
			dialogBody={
				<div className={classes.jawazakDialogBodyWrapper}>
					<div className={classes.jawazakBodyWrapper}>
						<BodyM disableMargin>{translate('number.services.jawazak.select.package')}</BodyM>
					</div>
					<JawazakTable
						catalogEntryView={catalogEntryView}
						setSelectedCatalogEntryView={setSelectedCatalogEntryView}
					/>
					<div className={classes.termsAndConditionsWrapper}>
						<VatClause />
						<DialogTermsAndConditions
							termsAndConditions={termsAndConditions}
							isChecked={isChecked}
							setIsChecked={setIsChecked}
							showError={showError}
							showCheckbox
						/>
					</div>
				</div>
			}
			rightSideButtons={[
				{
					text: translate('cancel'),
					color: 'tertiary-light',
					onClick: hideDialog,
				},
				{
					text: translate('number.services.top.up'),
					color: 'primary-light',
					disabled: activationButtonDisabled,
					onClick: activateJawazak,
				},
			]}
		/>
	);
};

export default JawazakActivationDialog;
